import React, {useState} from 'react';

import {pluralize} from 'BenchlingUtil';
import {ButtonStyle} from 'ui-library/buttons/Button';
import ControlledNumericInput from 'ui-library/inputs/ControlledNumericInput';
import Modal from 'ui-library/modals/Modal';

/**
 * This modal allows the user to enter the number of rows they wish to add to a table.
 */

interface AddRowsModalProps {
  onRequestClose: () => void;
  onRequestSubmit: (numRows: number) => void;
  max: number;
}

export default function AddRowsModal(props: AddRowsModalProps): JSX.Element {
  const [numRows, setNumRows] = useState<number | null>(1);
  const [text, setText] = useState('1');

  return (
    <Modal
      onRequestClose={props.onRequestClose}
      title="Add rows"
      onRequestSubmit={() => {
        props.onRequestSubmit(numRows!);
      }}
      buttons={[
        {
          submit: true,
          text: `Add ${numRows != null && numRows > 0 ? numRows : ''} rows`,
          disabled: numRows == null || numRows <= 0 || numRows > props.max,
          style: ButtonStyle.SECONDARY,
        },
      ]}
    >
      <ControlledNumericInput
        min={1}
        value={numRows ?? text}
        focusOnMount={true}
        onChange={({target: {value, numericValue}}) => {
          setText(value);
          setNumRows(numericValue);
        }}
      />
      {numRows != null && numRows > props.max && (
        <p>
          You can only add {props.max} {pluralize(props.max, 'row')} to this table.
        </p>
      )}
    </Modal>
  );
}
